import { identifyEnvironment as identifyJsQEnvironment, environments } from "@jsq/utils";

/**
 * Identify the JSQ deployment environment for Datadog RUM.
 *
 * Delegates hostname parsing to `@jsq/utils`, then maps the result to the
 * string shape this package has always exposed (preview/IPE hosts report the
 * hostname segment itself rather than a generic "preview" label).
 */
export function identifyEnvironment(): string {
  const { environmentType, environmentKey } = identifyJsQEnvironment();

  if (environmentType === environments.communal) {
    // Keep the legacy contract: communal hosts report as preview.
    return "prcom2";
  }

  if (environmentType === environments.preview) {
    return environmentKey ?? environments.unknown;
  }

  return environmentType;
}
